import type { ReactElement } from 'react';

import ReactSerializer from '@atlaskit/renderer/react';
import type { ReactSerializerInit } from '@atlaskit/renderer/react';

type FragmentArgs = Parameters<ReactSerializer['serializeFragment']>;
export type FullNodeRecords = Map<string, Pick<FragmentArgs, 1 | 2>>;
type SerializerParentInfo = { path: unknown[]; pos: number };

/** Restore document-wide props and full targets when serializing an activated subtree. */
export class FullBatchSerializer extends ReactSerializer {
	constructor(
		init: ReactSerializerInit,
		private records: FullNodeRecords,
	) {
		super(init);
	}

	serializeFragment(...args: FragmentArgs): ReactElement | null {
		const [fragment, props, target, key, parent] = args;
		const parentInfo = parent as SerializerParentInfo | undefined;
		// Platform's raw position can be shared by a parent and its first descendant.
		const record = parentInfo
			? this.records.get(`${parentInfo.pos}:${parentInfo.path.length}`)
			: undefined;
		const fullProps = record?.[1] ?? props;
		const fullTarget = record?.[2] ?? target;
		return super.serializeFragment(fragment, fullProps, fullTarget, key, parent);
	}
}
